import { __awaiter } from "tslib";
import { Subject } from 'rxjs';
import { LoadedState, ReadyState, timeoutByConnection } from "../shared/index.js";
const state = {
    loadedState: LoadedState.NOT_LOADED,
    readyState: ReadyState.NOT_READY
};
const queueEmpty$ = new Subject();
let onReadyResolver;
const onReadyPromise = new Promise((resolve) => {
    onReadyResolver = resolve;
});
const waitForReadyOrTimeout = () => Promise.race([timeoutByConnection(), onReadyPromise]);
const onReady = () => {
    state.readyState = ReadyState.READY;
    onReadyResolver();
};
const onLoadedStateChanged = (loadedState) => {
    state.loadedState = loadedState;
};
const initTracker = (_, retryLoading) => {
    var _a;
    const win = window;
    win.dataLayer = win.dataLayer || [];
    if ((_a = win === null || win === void 0 ? void 0 : win.pulse) === null || _a === void 0 ? void 0 : _a.tracker) {
        win.pulse.tracker.queue.batchQueue.queueEmpty$.subscribe((res) => queueEmpty$.next(res));
    }
    else {
        waitForReadyOrTimeout().then(() => __awaiter(void 0, void 0, void 0, function* () {
            if (state.loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER) {
                retryLoading();
            }
        }));
        onReadyPromise.then(() => {
            win.pulse.tracker.queue.batchQueue.queueEmpty$.subscribe((res) => queueEmpty$.next(res));
        });
    }
    return {
        queueEmpty$
    };
};
export { initTracker, onLoadedStateChanged as onTrackerLoadingStateChanged, onReady as onTrackerReady, state as trackerState };
//# sourceMappingURL=tracker.service.js.map